__turbopack_context__.v({
  "blink": "AllModules-module-scss-module__Zw6kwW__blink",
  "sectionColumns": "AllModules-module-scss-module__Zw6kwW__sectionColumns",
  "sectionIntroduction": "AllModules-module-scss-module__Zw6kwW__sectionIntroduction",
});
